import './Header.css';
import logo4 from '../../assets/images/logo4.png';

function Header() {
    return (
        <header>
            <img src={logo4} alt='logo1' />
        </header>
    )
}

export default Header;